export const datetimeFormat = "ddd, MMM D, h:mm A";
export const datetimeFormatShort = "MMM D, h:mm A";
